import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Header-css/ServicePartner/OtpPopup.css'; 

const OtpPopup = ({ phoneNumber, onClose, onSubmit }) => {
  const [otp, setOtp] = useState(new Array(6).fill(''));
  const [timer, setTimer] = useState(30);
  const inputRefs = useRef([]);

  // --- Countdown Timer ---
  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  // --- Input Handling ---
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return; 

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && e.target.previousSibling) {
      e.target.previousSibling.focus();
    }
  };

  const handlePaste = (e) => {
    const value = e.clipboardData.getData('text');
    if (isNaN(value) || value.length !== 6) return;
    const newOtp = value.split('');
    setOtp(newOtp);
    inputRefs.current[5].focus(); 
  };
  
  const handleSubmit = () => {
    const enteredOtp = otp.join('');
    if (enteredOtp.length === 6) {
      onSubmit(enteredOtp);
    } else {
      alert("Please enter the complete 6-digit OTP.");
    }
  };

  const handleResend = () => {
    if (timer === 0) {
      setOtp(new Array(6).fill(''));
      setTimer(30); 
    }
  };

  return (
    <div className="otp-modal-overlay" onClick={onClose}>
      <div className="otp-modal-box" onClick={(e) => e.stopPropagation()}>
        
        {/* --- NEW CLOSE BUTTON --- */}
        <button className="otp-close-btn" onClick={onClose}>
          &times;
        </button>

        <h2>OTP Verification</h2>
        <p>OTP has been sent to +91 {phoneNumber}</p>
        
        <div className="otp-input-container">
          {otp.map((data, index) => (
            <input
              key={index}
              type="text"
              className="otp-input"
              maxLength="1"
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onFocus={(e) => e.target.select()}
              onPaste={index === 0 ? handlePaste : null} 
              ref={(el) => (inputRefs.current[index] = el)}
            />
          ))}
        </div>

        <div className="otp-timer-resend">
          <p className="timer">00:{timer < 10 ? `0${timer}` : timer}</p>
          <button 
            className={`resend-btn ${timer > 0 ? 'disabled' : ''}`}
            onClick={handleResend}
            disabled={timer > 0}
          >
            Didn't get it? Send OTP (SMS)
          </button>
        </div>

        <button className="continue-btn" onClick={handleSubmit}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default OtpPopup;